import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../redux/actions/auth';
import { useFormik } from 'formik';
import * as yup from 'yup';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Alert, AlertTitle } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import ProjectTitle from '../components/ProjectTitle';

import BackgroundImage from '../assets/img/harran.png';

const validationsForm = yup.object({
  email: yup
    .string()
    .email('Geçerli bir mail adresi giriniz.')
    .required('Email adresinizi giriniz.'),
});

const theme = createTheme();

const ResetPasswordPage = (props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { message } = useSelector((state) => state.authMessage);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: validationsForm,
    onSubmit: (values) => {
      const { email } = values;

      setLoading(true);
      dispatch(forgotPassword(email))
        .then(() => {
          props.history.push('/');
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
        });
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          minHeight: '100vh',
          border: '0.1px solid black',
        }}
      >
        <Container component="main" maxWidth="xs">
          <Grid
            container
            component="main"
            sx={{
              verticalAlign: 'center',
              marginTop: '40%',
              marginBottom: '5%',
              alignContent: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              alignSelf: 'center',
            }}
          >
            <CssBaseline />
            <Grid item component={Paper} elevation={6} square>
              <Box
                sx={{
                  my: 8,
                  mx: 4,
                  marginTop: 8,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <ProjectTitle />
                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                  <LockOutlinedIcon />
                </Avatar>
                {loading && <CircularProgress />}
                <Typography component="h1" variant="h5">
                  Parolanızı Sıfırlayın
                </Typography>
                <Box
                  component="form"
                  onSubmit={formik.handleSubmit}
                  noValidate
                  sx={{ mt: 1 }}
                >
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="email"
                    label="E-Mail"
                    type="email"
                    id="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    Parolanızı Sıfırlayın
                  </Button>
                  {message && (
                    <Alert severity={message.type}>
                      <AlertTitle>Bilgi</AlertTitle>
                      <strong>{message.message}</strong>
                    </Alert>
                  )}
                </Box>
              </Box>
              <Copyright sx={{ mt: 8, mb: 4 }} />
            </Grid>
          </Grid>
        </Container>
      </div>
    </ThemeProvider>
  );
};

export default ResetPasswordPage;
